export const environment = {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    version: require('../../package.json').version,
    config: 'assets/config/config.json',
    production: false,
}
